const largeScreenMaxWidth = 767;
const additionalViewPortSpace = 1000;

export const largeScreen = () => {
  let windowWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
  return windowWidth > largeScreenMaxWidth;
};

export const isInViewport = (element) => {
  let rect = element.getBoundingClientRect();

  return (
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (window.innerHeight + additionalViewPortSpace || document.documentElement.clientHeight + additionalViewPortSpace) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
   );
};



// WEBPACK FOOTER //
// ./src/_assets/js/modules/utils.js